// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChargingPageCustom_Kratos_chargingMainDiv_Kratos__Oy-sI .ChargingPageCustom_Kratos_btn-primary__GQRHG{
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  }
  .ChargingPageCustom_Kratos_chargingMainDiv_Kratos__Oy-sI .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP{
    border-color: #83A4CF !important;
    color: #83A4CF !important;
  }
  .ChargingPageCustom_Kratos_chargingMainDiv_Kratos__Oy-sI .ChargingPageCustom_Kratos_ev_filter_icon__GD6TR {
    background: #fff !important;
    color: #83A4CF !important;
  }
  
  /* imp code commented */
  /* .chargingMainDiv_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  } */
  /* imp code commented */
  
  /*********************** Slow Button *************************/
  .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP{
    /* color:#83A4CF; */
    border-color:#83A4CF !important;
  }
  .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_btn-check__uKk\\+o:checked+.ChargingPageCustom_Kratos_btn__jlVTz:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz.ChargingPageCustom_Kratos_active__eQ8Ox:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz.ChargingPageCustom_Kratos_show__40hQW:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz:first-child:active:focus-visible, :not(.ChargingPageCustom_Kratos_btn-check__uKk\\+o)+.ChargingPageCustom_Kratos_btn__jlVTz:active:focus-visible {
    box-shadow: none;
  }
  .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP {
    --bs-btn-color: #83A4CF !important;
    --bs-btn-border-color: #83A4CF !important;
    --bs-btn-hover-color: #fff;
    --bs-btn-hover-bg: #83A4CF !important;
    --bs-btn-hover-border-color: #83A4CF !important;
    --bs-btn-focus-shadow-rgb: 13,110,253;
    --bs-btn-active-color: #fff;
    --bs-btn-active-bg: #83A4CF !important;
    --bs-btn-active-border-color: #83A4CF !important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #83A4CF !important;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #83A4CF !important;
    --bs-gradient: none;
  }
  
  .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP:not(:disabled):not(.ChargingPageCustom_Kratos_disabled__q0hux):active, .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP:not(:disabled):not(.ChargingPageCustom_Kratos_disabled__q0hux).ChargingPageCustom_Kratos_active__eQ8Ox, .ChargingPageCustom_Kratos_show__40hQW>.ChargingPageCustom_Kratos_btn-outline-primary__GlHzP.ChargingPageCustom_Kratos_dropdown-toggle__PAmzY {
    /* color: #fff; */
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
    }
    .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_ev_SButton__fMmwa {
      background: none !important;
      color: #7b7878 !important;
      border-color: #7b7878 !important;
    }
  
  /* imp code commented */
  /* .kpiSlowBTN_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  } */
  /* imp code commented */
  
  .ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g .ChargingPageCustom_Kratos_btn-outline-primary__GlHzP:hover{
    background-color: #83A4CF !important;
    border-color: #83A4CF !important;
  }
  /*********************** Slow Button Ends *************************/
  
  
  /*********************** Fast Button *************************/
  .ChargingPageCustom_Kratos_kpiFastBTN_Kratos__G-sw6 .ChargingPageCustom_Kratos_btn-outline-warning__5fnp0{
    /* color:#3578b0; */
    /* border-color:#3578b0 !important; */
  }
  .ChargingPageCustom_Kratos_kpiFastBTN_Kratos__G-sw6 .ChargingPageCustom_Kratos_btn-check__uKk\\+o:checked+.ChargingPageCustom_Kratos_btn__jlVTz:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz.ChargingPageCustom_Kratos_active__eQ8Ox:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz.ChargingPageCustom_Kratos_show__40hQW:focus-visible, .ChargingPageCustom_Kratos_btn__jlVTz:first-child:active:focus-visible, :not(.ChargingPageCustom_Kratos_btn-check__uKk\\+o)+.ChargingPageCustom_Kratos_btn__jlVTz:active:focus-visible {
    box-shadow: none;
  }
  .ChargingPageCustom_Kratos_kpiFastBTN_Kratos__G-sw6 .ChargingPageCustom_Kratos_btn-outline-warning__5fnp0 {
    --bs-btn-color: #3578b0 !important;
    --bs-btn-border-color: #3578b0 !important;
    --bs-btn-hover-color: #000;
    --bs-btn-hover-bg: #3578b0 !important;
    --bs-btn-hover-border-color: #3578b0 !important;
    --bs-btn-focus-shadow-rgb: 255,193,7;
    --bs-btn-active-color: #000;
    --bs-btn-active-bg: #3578b0 !important;
    --bs-btn-active-border-color: #3578b0 !important;
    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    --bs-btn-disabled-color: #3578b0 !important;
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: #3578b0 !important;
    --bs-gradient: none;
  }
  
  .ChargingPageCustom_Kratos_kpiFastBTN_Kratos__G-sw6 .ChargingPageCustom_Kratos_ev_FButton__LeNUz {
    background: none !important;
    /* color: #3578b0 !important; */
    /* background: #7b7878 !important; */
    /* border: #7b7878; */
    border-color: #7b7878;
  }
  
  /* imp code commented */
  /* .kpiFastBTN_Bus .btn:focus,
  .btn:focus-visible,
  .btn:focus-within,
  .btn:hover,
  .btn:visited,
  .btn:active,
  .btn:target{
    color: #fff !important;
    background-color: #3578b0;
    border-color: #3578b0;
  } */
  /* imp code commented */
  /*********************** Fast Button Ends *************************/
  
  .ChargingPageCustom_Kratos_bg-white__yJg2Y{
      background-color:#fff;
  }
  
  .ChargingPageCustom_Kratos_chargingMainDiv_Kratos__Oy-sI{
      /* margin-top:80px; */
    margin-top: 15px;
  }
  
  .ChargingPageCustom_Kratos_chargingWidget_Kratos__Ns5aI{
      /* background: #fff; */
      box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
      border-radius: 5px;
    background: #CDDAEA;
  }
  .ChargingPageCustom_Kratos_chargingWidgetIcon_Kratos__kNE7a img{
      width:50px;
      height:50px;
  }
  .ChargingPageCustom_Kratos_chargingWidgetIcon1_Kratos__EFiH6 img{
      width:35px;
      height:35px;
  }
  .ChargingPageCustom_Kratos_chargingWidgetIcon_Kratos-32_Kratos__nsi6J img{
      width:32px;height:32px;
  }
  .ChargingPageCustom_Kratos_chargingTitleBg_Kratos__r8cqb {
    /* font-size: 1em;
    color: #0E3157;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: left;
    background: #E0E0E0;
      border-radius: 5px 5px 0 0; */
  
    font-size: 1em;
    color: #0E3157;
    font-weight: 600;
    margin-bottom: 10px;
    text-align: center;
    background: #E0E0E0;
    border-radius: 5px 5px 0 0;
    /* margin-top: -12px;
    margin-left: -10px;
    margin-right: -10px; */
  }
  .ChargingPageCustom_Kratos_chargingTitleChart_Kratos__7pwL5 {
      font-size: 0.9em;
      color: #0E3157;
      /* color: #353535; */
      font-weight: 600;
      margin-bottom: 10px;
      text-align: left;
      background: #E0E0E0;
        border-radius: 5px 5px 0 0;
      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  }
  
  .ChargingPageCustom_Kratos_chargingChartbox_Kratos__iWWsf{
      /* background: #FFFFFF;
      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
      color: #353535;
      min-height: 280px;
      border-radius: 5px; */
    background: #FFFFFF;
    padding: 0px;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  }
  
  .ChargingPageCustom_Kratos_wd_Kratos__-v0cR{
      min-height: 330px !important;
  }
  .ChargingPageCustom_Kratos_wd_4_charts_Kratos__6FquW{
      min-height: 307px !important;
    }
  .ChargingPageCustom_Kratos_highlightBoxKpi_Kratos__0xe53{
      /* min-height: 310px !important; */
  }
  .ChargingPageCustom_Kratos_highlightTableSec_Kratos__0DY8A{
      min-height: 310px !important;
  }
  .ChargingPageCustom_Kratos_chargingChartHGT_Kratos__ujkIh{
      padding: 10px;
  }
  
  .ChargingPageCustom_Kratos_chargingH5_Kratos__9bpAI .ChargingPageCustom_Kratos_h5__uVxsu {
      font-size: 1rem !important;
      /* font-size: 1.1rem !important; */
  }
  .ChargingPageCustom_Kratos_chargingKpiSmallTxt_Kratos__fdnqX{
      font-size: 77% !important;
      line-height: 1em !important;
  }
  
  .ChargingPageCustom_Kratos_tableContent_Kratos__IIWV2 table tr td {
      font-size:0.8em;
  }
  
  .ChargingPageCustom_Kratos_chargingFilterForm_Kratos__Y\\+-k5 > .ChargingPageCustom_Kratos_form-label__Mk1TL{
      font-size:0.825em;
  }
  
  .ChargingPageCustom_Kratos_chargingHeadfont_Kratos__WYUd-{
      font-size:1.8rem;
  }
  .ChargingPageCustom_Kratos_topRightDropMenu_Kratos__jdXt- .ChargingPageCustom_Kratos_dropdown-menu__cnEb6[data-bs-popper] {
      right:0 !important;
      left: auto;
  }
  
  /********************  *********************/
  
  .ChargingPageCustom_Kratos_contentScroll_Kratos__vCcDo{
      /* overflow-y: scroll; */
      /* height:150px; */
  }
  
  .ChargingPageCustom_Kratos_chargingWidget_Kratos__Ns5aI p {
      line-height: 1rem !important;
  }
  .ChargingPageCustom_Kratos_chargingWidget_Kratos__Ns5aI p small{
      font-size:80% !important;
  }
  
  /***************************** Toggle Switch ***************************/
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_form-switch__us3Zg .ChargingPageCustom_Kratos_form-check-input__cZm8T:checked:before {
      content: "C";
      position: absolute;
      width: 20px;
      height: 10px;
      padding-left: 20px;
      margin-top: -1px;
      font-size: 0.7em;
  }
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_form-switch__us3Zg .ChargingPageCustom_Kratos_form-check-input__cZm8T:before{
      content: "V";
      position: absolute;
      width: 20px;
      height: 10px;
      padding-left: 5px;
      margin-top: -1px;
      font-size: 0.7em;
  }
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_form-switch__us3Zg .ChargingPageCustom_Kratos_form-check-input__cZm8T{
      color:#83A4CF !important;
  }
  
  /* k */
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_toggle-button-cover__lpbDg {
    position: relative;
    top: 8px;
  }
  .ChargingPageCustom_Kratos_dropdownSelectBtnCharging_Kratos__CgChf{
      width: fit-content;
  }
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_button-cover__pSwkC {
    background-color: #fff;
    box-shadow: 0 10px 20px -8px #c5d6d6;
    border-radius: 4px;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_button-cover__pSwkC:before {
    color: #d7e3e3;
    font-size: 12px;
    line-height: 1;
    padding: 5px;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_button-cover__pSwkC,
  .ChargingPageCustom_Kratos_knobs__W3lBd,
  .ChargingPageCustom_Kratos_layer__HpCO0 {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_buttonbtn__4Ibpi {
    position: relative;
    top: 50%;
    width: 50px;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_buttonbtn__4Ibpi.ChargingPageCustom_Kratos_r__5u9x1,
  .ChargingPageCustom_Kratos_buttonbtn__4Ibpi.ChargingPageCustom_Kratos_r__5u9x1 .ChargingPageCustom_Kratos_layer__HpCO0 {
    border-radius: 100px;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_button__\\+W\\+io.ChargingPageCustom_Kratos_b2__eUTEH {
    border-radius: 2px;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_checkbox__h0pn5 {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_knobs__W3lBd {
    z-index: 2;
  }
  
  .ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ .ChargingPageCustom_Kratos_layer__HpCO0 {
    width: 100%;
    background-color: #ebf7fc;
    transition: 0.3s ease all;
    z-index: 1;
  }
  /* Button 1 */
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_knobs__W3lBd:before {
    content: "V";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 20px;
    height: 20px;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 6px 4px;
    background-color: #83A4CF;
    border-radius: 50%;
    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
  }
  
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_checkbox__h0pn5:checked + .ChargingPageCustom_Kratos_knobs__W3lBd:before {
    content: "C";
    left: 30px;
    background-color: #3578b0;
  }
  
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_checkbox__h0pn5:checked ~ .ChargingPageCustom_Kratos_layer__HpCO0 {
    /* fent orange change */
    /* background-color: #fcebeb; */
    background-color: #94c1e6;
  }
  
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_knobs__W3lBd,
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_knobs__W3lBd:before,
  #ChargingPageCustom_Kratos_button-1_Kratos__cnPdg .ChargingPageCustom_Kratos_layer__HpCO0 {
    transition: 0.3s ease all;
  }
  
  /***************************** PageTwo *******************************/
  
  /*************************  *****************************/
  .ChargingPageCustom_Kratos_kpiNotificationSlow_Kratos__7ER7N{
      color: #83A4CF;
      font-size: 0.7em;
      font-weight: 500;
  }
  .ChargingPageCustom_Kratos_kpiNotificationFast_Kratos__I0Jk\\+{
      color:#3578b0;
      font-size:0.7em;
      font-weight:500;
  }
  
  .ChargingPageCustom_Kratos_kpiNotificationBoth_Kratos__rAXDT{
      color:#72D817;
      font-size:0.7em;
      font-weight:500;
  }
  /* media queries start here */
  
  @media (min-width: 1440px) {
  .ChargingPageCustom_Kratos_col205__TISR7{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  @media (max-width: 1440px) {
  .ChargingPageCustom_Kratos_highlightTableSec_Kratos__0DY8A{
      min-height: 310px !important;
  }
  }
  
  @media (min-width: 1336px) {
  .ChargingPageCustom_Kratos_col205__TISR7{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  
  @media (max-width: 1024px) {
  .ChargingPageCustom_Kratos_highlightTableSec_Kratos__0DY8A{
      min-height: 330px !important;
  }
  }
  
  
  @media (min-width: 992px) {
  .ChargingPageCustom_Kratos_col205__TISR7{
      flex: 0 0 auto;
      width: 20% !important;
  }
  }
  
  
  @media (min-width: 836px) {
  /* .navbar-expand-sm { */
      /* flex-wrap: nowrap !important; */
      /* justify-content: flex-start !important; */
  /* } */
  }
  
  @media screen and (max-width: 740px) {
  .ChargingPageCustom_Kratos_chargingTitleBg_Kratos__r8cqb {
      font-size: 0.9em;
  }
  }
  
  
  @media screen and (max-width: 720px) {
  /* .chargingMainDiv_Bus{ */
      /* margin-top:124px; */
  /* } */
  }
  
  @media screen and (max-width: 480px) {
  /* .chargingMainDiv_Bus{ */
      /* margin-top:155px; */
  /* } */
  }
      
  @media screen and (max-width: 480px) {
  
  .ChargingPageCustom_Kratos_chargingHeadfont_Kratos__WYUd- {
      font-size: 1rem;
  }
  .ChargingPageCustom_Kratos_chargingTitleBg_Kratos__r8cqb {
      font-size: 0.9em;
  }
  }
  
  @media screen and (max-width: 320px) {
  
  }
  
  .ChargingPageCustom_Kratos_highlight_five_Kratos__qB2BU{
    margin: auto;
  }
  
  .ChargingPageCustom_Kratos_text_bottom_Kratos__kfXrW{
    margin-bottom: '-16px !important';
    display: none;
    z-index: 1;
  }
  .ChargingPageCustom_Kratos_btn-infotable_Kratos__nMhWs:active {
    color: black;
    background-color: #fff;
    border-color: #32879c; 
  }
  
  /* .col-19 {
    flex: 0 0 calc(100% / 19);
    max-width: calc(100% / 19);
  } */
  
  @media (min-width: 1440px) {
    .ChargingPageCustom_Kratos_col-19__KVKTO {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  @media (min-width: 1336px) {
    .ChargingPageCustom_Kratos_col-19__KVKTO {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  @media (min-width: 992px) {
    .ChargingPageCustom_Kratos_col-19__KVKTO {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: calc(100% / 19);
    max-width: calc(100% / 19);
    }
  }
  
  
  /* @media (max-width: 576px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 576px) and (max-width: 768px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 768px) and (max-width: 992px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  }
  
  @media (min-width: 992px) {
    .col-19 {
        flex: 0 0 calc(100% / 19);
        max-width: calc(100% / 19);
      }
  } */
  
  .ChargingPageCustom_Kratos_chargingChartboxNew_Kratos__5ORso {
    background: #FFFFFF;
    padding: 0px;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    height: 293px;
  }
  
  .ChargingPageCustom_Kratos_highBold__X-crn {
    font-weight: bold;
    color: black;
    font-size:16px !important
  }
  
  .ChargingPageCustom_Kratos_filter_kratos_icon_f__cAFSw .ChargingPageCustom_Kratos_rca_btn__lGWjQ .ChargingPageCustom_Kratos_rca_btn_kratos__oKFaY  {
    background-color: #ffa650;
  }
  .ChargingPageCustom_Kratos_filter_kratos_icon_f__cAFSw .ChargingPageCustom_Kratos_rca_btn__lGWjQ .ChargingPageCustom_Kratos_rca_btn_kratos__oKFaY:hover{
    background-color: #fcb877 !important; 
    border-color: #fcb877 !important;
  }
  
  .ChargingPageCustom_Kratos_popUpTable__ApGz8{
    background-color: rgb(131, 164, 207);
    color: rgb(255, 255, 255);
    position: sticky;
    top: 0;
    z-index: 0;
  }
  
  .ChargingPageCustom_Kratos_custom-table__75i\\+K .ChargingPageCustom_Kratos_p-datatable-thead__jAi5u th {
    background-color: #83A4CF;
    /* Set your desired background color */
    color: white;
    /* Set your desired text color */
  }
  
  /* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */
  .ChargingPageCustom_Kratos_custom-table__75i\\+K .ChargingPageCustom_Kratos_p-sortable-column__6pzrP .ChargingPageCustom_Kratos_p-column-header-content__6K7aF .ChargingPageCustom_Kratos_p-sortable-column-icon__w-Xkj {
    color: white;
    height: 20px!important;
    width: 12px!important;
    /* Set your desired arrow color */
  }`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/Charginganalysis_Kratos/ChargingPageCustom_Kratos.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;;EAEvB,8DAA8D;EAC9D;IACE,mBAAmB;IACnB,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yCAAyC;IACzC,0BAA0B;IAC1B,qCAAqC;IACrC,+CAA+C;IAC/C,qCAAqC;IACrC,2BAA2B;IAC3B,sCAAsC;IACtC,gDAAgD;IAChD,4DAA4D;IAC5D,2CAA2C;IAC3C,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;IACpC,gCAAgC;IAChC;IACA;MACE,2BAA2B;MAC3B,yBAAyB;MACzB,gCAAgC;IAClC;;EAEF,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;;EAEvB;IACE,oCAAoC;IACpC,gCAAgC;EAClC;EACA,mEAAmE;;;EAGnE,8DAA8D;EAC9D;IACE,mBAAmB;IACnB,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,yCAAyC;IACzC,0BAA0B;IAC1B,qCAAqC;IACrC,+CAA+C;IAC/C,oCAAoC;IACpC,2BAA2B;IAC3B,sCAAsC;IACtC,gDAAgD;IAChD,4DAA4D;IAC5D,2CAA2C;IAC3C,iCAAiC;IACjC,kDAAkD;IAClD,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;IAC/B,oCAAoC;IACpC,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA,uBAAuB;EACvB;;;;;;;;;;KAUG;EACH,uBAAuB;EACvB,mEAAmE;;EAEnE;MACI,qBAAqB;EACzB;;EAEA;MACI,qBAAqB;IACvB,gBAAgB;EAClB;;EAEA;MACI,sBAAsB;MACtB,4CAA4C;MAC5C,kBAAkB;IACpB,mBAAmB;EACrB;EACA;MACI,UAAU;MACV,WAAW;EACf;EACA;MACI,UAAU;MACV,WAAW;EACf;EACA;MACI,UAAU,CAAC,WAAW;EAC1B;EACA;IACE;;;;;;mCAM+B;;IAE/B,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B;;0BAEsB;EACxB;EACA;MACI,gBAAgB;MAChB,cAAc;MACd,oBAAoB;MACpB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;MAChB,mBAAmB;QACjB,0BAA0B;MAC5B,wCAAwC;EAC5C;;EAEA;MACI;;;;2BAIqB;IACvB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;MACI,4BAA4B;EAChC;EACA;MACI,4BAA4B;IAC9B;EACF;MACI,kCAAkC;EACtC;EACA;MACI,4BAA4B;EAChC;EACA;MACI,aAAa;EACjB;;EAEA;MACI,0BAA0B;MAC1B,kCAAkC;EACtC;EACA;MACI,yBAAyB;MACzB,2BAA2B;EAC/B;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,gBAAgB;EACpB;EACA;MACI,kBAAkB;MAClB,UAAU;EACd;;EAEA,4CAA4C;;EAE5C;MACI,wBAAwB;MACxB,kBAAkB;EACtB;;EAEA;MACI,4BAA4B;EAChC;EACA;MACI,wBAAwB;EAC5B;;EAEA,wEAAwE;EACxE;MACI,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,wBAAwB;EAC5B;;EAEA,MAAM;EACN;IACE,kBAAkB;IAClB,QAAQ;EACV;EACA;MACI,kBAAkB;EACtB;EACA;IACE,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;;;IAGE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,UAAU;IACV,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;EACZ;EACA,aAAa;EACb;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,yDAAyD;EAC3D;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA,sEAAsE;;EAEtE,yDAAyD;EACzD;MACI,cAAc;MACd,gBAAgB;MAChB,gBAAgB;EACpB;EACA;MACI,aAAa;MACb,eAAe;MACf,eAAe;EACnB;;EAEA;MACI,aAAa;MACb,eAAe;MACf,eAAe;EACnB;EACA,6BAA6B;;EAE7B;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;EAEA;EACA;MACI,4BAA4B;EAChC;EACA;;EAEA;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;;EAGA;EACA;MACI,4BAA4B;EAChC;EACA;;;EAGA;EACA;MACI,cAAc;MACd,qBAAqB;EACzB;EACA;;;EAGA;EACA,wBAAwB;MACpB,kCAAkC;MAClC,4CAA4C;EAChD,MAAM;EACN;;EAEA;EACA;MACI,gBAAgB;EACpB;EACA;;;EAGA;EACA,0BAA0B;MACtB,sBAAsB;EAC1B,MAAM;EACN;;EAEA;EACA,0BAA0B;MACtB,sBAAsB;EAC1B,MAAM;EACN;;EAEA;;EAEA;MACI,eAAe;EACnB;EACA;MACI,gBAAgB;EACpB;EACA;;EAEA;;EAEA;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,aAAa;IACb,UAAU;EACZ;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;;;KAGG;;EAEH;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;EAEA;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;EAEA;IACE;MACE,YAAyB;MAAzB,cAAyB;MAAzB,2BAAyB;IAC3B,0BAA0B;IAC1B;EACF;;;EAGA;;;;;;;;;;;;;;;;;;;;;;;;;;KA0BG;;EAEH;IACE,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ;EACF;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,YAAY;IACZ,gCAAgC;EAClC;;EAEA,uFAAuF;EACvF;IACE,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,iCAAiC;EACnC","sourcesContent":[".chargingMainDiv_Kratos .btn-primary{\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  }\n  .chargingMainDiv_Kratos .btn-outline-primary{\n    border-color: #83A4CF !important;\n    color: #83A4CF !important;\n  }\n  .chargingMainDiv_Kratos .ev_filter_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n  }\n  \n  /* imp code commented */\n  /* .chargingMainDiv_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  } */\n  /* imp code commented */\n  \n  /*********************** Slow Button *************************/\n  .kpiSlowBTN_Kratos .btn-outline-primary{\n    /* color:#83A4CF; */\n    border-color:#83A4CF !important;\n  }\n  .kpiSlowBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n    box-shadow: none;\n  }\n  .kpiSlowBTN_Kratos .btn-outline-primary {\n    --bs-btn-color: #83A4CF !important;\n    --bs-btn-border-color: #83A4CF !important;\n    --bs-btn-hover-color: #fff;\n    --bs-btn-hover-bg: #83A4CF !important;\n    --bs-btn-hover-border-color: #83A4CF !important;\n    --bs-btn-focus-shadow-rgb: 13,110,253;\n    --bs-btn-active-color: #fff;\n    --bs-btn-active-bg: #83A4CF !important;\n    --bs-btn-active-border-color: #83A4CF !important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #83A4CF !important;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #83A4CF !important;\n    --bs-gradient: none;\n  }\n  \n  .kpiSlowBTN_Kratos .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {\n    /* color: #fff; */\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n    }\n    .kpiSlowBTN_Kratos .ev_SButton {\n      background: none !important;\n      color: #7b7878 !important;\n      border-color: #7b7878 !important;\n    }\n  \n  /* imp code commented */\n  /* .kpiSlowBTN_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  } */\n  /* imp code commented */\n  \n  .kpiSlowBTN_Kratos .btn-outline-primary:hover{\n    background-color: #83A4CF !important;\n    border-color: #83A4CF !important;\n  }\n  /*********************** Slow Button Ends *************************/\n  \n  \n  /*********************** Fast Button *************************/\n  .kpiFastBTN_Kratos .btn-outline-warning{\n    /* color:#3578b0; */\n    /* border-color:#3578b0 !important; */\n  }\n  .kpiFastBTN_Kratos .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n    box-shadow: none;\n  }\n  .kpiFastBTN_Kratos .btn-outline-warning {\n    --bs-btn-color: #3578b0 !important;\n    --bs-btn-border-color: #3578b0 !important;\n    --bs-btn-hover-color: #000;\n    --bs-btn-hover-bg: #3578b0 !important;\n    --bs-btn-hover-border-color: #3578b0 !important;\n    --bs-btn-focus-shadow-rgb: 255,193,7;\n    --bs-btn-active-color: #000;\n    --bs-btn-active-bg: #3578b0 !important;\n    --bs-btn-active-border-color: #3578b0 !important;\n    --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n    --bs-btn-disabled-color: #3578b0 !important;\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: #3578b0 !important;\n    --bs-gradient: none;\n  }\n  \n  .kpiFastBTN_Kratos .ev_FButton {\n    background: none !important;\n    /* color: #3578b0 !important; */\n    /* background: #7b7878 !important; */\n    /* border: #7b7878; */\n    border-color: #7b7878;\n  }\n  \n  /* imp code commented */\n  /* .kpiFastBTN_Bus .btn:focus,\n  .btn:focus-visible,\n  .btn:focus-within,\n  .btn:hover,\n  .btn:visited,\n  .btn:active,\n  .btn:target{\n    color: #fff !important;\n    background-color: #3578b0;\n    border-color: #3578b0;\n  } */\n  /* imp code commented */\n  /*********************** Fast Button Ends *************************/\n  \n  .bg-white{\n      background-color:#fff;\n  }\n  \n  .chargingMainDiv_Kratos{\n      /* margin-top:80px; */\n    margin-top: 15px;\n  }\n  \n  .chargingWidget_Kratos{\n      /* background: #fff; */\n      box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n      border-radius: 5px;\n    background: #CDDAEA;\n  }\n  .chargingWidgetIcon_Kratos img{\n      width:50px;\n      height:50px;\n  }\n  .chargingWidgetIcon1_Kratos img{\n      width:35px;\n      height:35px;\n  }\n  .chargingWidgetIcon_Kratos-32_Kratos img{\n      width:32px;height:32px;\n  }\n  .chargingTitleBg_Kratos {\n    /* font-size: 1em;\n    color: #0E3157;\n    font-weight: 500;\n    margin-bottom: 10px;\n    text-align: left;\n    background: #E0E0E0;\n      border-radius: 5px 5px 0 0; */\n  \n    font-size: 1em;\n    color: #0E3157;\n    font-weight: 600;\n    margin-bottom: 10px;\n    text-align: center;\n    background: #E0E0E0;\n    border-radius: 5px 5px 0 0;\n    /* margin-top: -12px;\n    margin-left: -10px;\n    margin-right: -10px; */\n  }\n  .chargingTitleChart_Kratos {\n      font-size: 0.9em;\n      color: #0E3157;\n      /* color: #353535; */\n      font-weight: 600;\n      margin-bottom: 10px;\n      text-align: left;\n      background: #E0E0E0;\n        border-radius: 5px 5px 0 0;\n      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  }\n  \n  .chargingChartbox_Kratos{\n      /* background: #FFFFFF;\n      box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n      color: #353535;\n      min-height: 280px;\n      border-radius: 5px; */\n    background: #FFFFFF;\n    padding: 0px;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  }\n  \n  .wd_Kratos{\n      min-height: 330px !important;\n  }\n  .wd_4_charts_Kratos{\n      min-height: 307px !important;\n    }\n  .highlightBoxKpi_Kratos{\n      /* min-height: 310px !important; */\n  }\n  .highlightTableSec_Kratos{\n      min-height: 310px !important;\n  }\n  .chargingChartHGT_Kratos{\n      padding: 10px;\n  }\n  \n  .chargingH5_Kratos .h5 {\n      font-size: 1rem !important;\n      /* font-size: 1.1rem !important; */\n  }\n  .chargingKpiSmallTxt_Kratos{\n      font-size: 77% !important;\n      line-height: 1em !important;\n  }\n  \n  .tableContent_Kratos table tr td {\n      font-size:0.8em;\n  }\n  \n  .chargingFilterForm_Kratos > .form-label{\n      font-size:0.825em;\n  }\n  \n  .chargingHeadfont_Kratos{\n      font-size:1.8rem;\n  }\n  .topRightDropMenu_Kratos .dropdown-menu[data-bs-popper] {\n      right:0 !important;\n      left: auto;\n  }\n  \n  /********************  *********************/\n  \n  .contentScroll_Kratos{\n      /* overflow-y: scroll; */\n      /* height:150px; */\n  }\n  \n  .chargingWidget_Kratos p {\n      line-height: 1rem !important;\n  }\n  .chargingWidget_Kratos p small{\n      font-size:80% !important;\n  }\n  \n  /***************************** Toggle Switch ***************************/\n  .toggleBtn_Kratos .form-switch .form-check-input:checked:before {\n      content: \"C\";\n      position: absolute;\n      width: 20px;\n      height: 10px;\n      padding-left: 20px;\n      margin-top: -1px;\n      font-size: 0.7em;\n  }\n  .toggleBtn_Kratos .form-switch .form-check-input:before{\n      content: \"V\";\n      position: absolute;\n      width: 20px;\n      height: 10px;\n      padding-left: 5px;\n      margin-top: -1px;\n      font-size: 0.7em;\n  }\n  .toggleBtn_Kratos .form-switch .form-check-input{\n      color:#83A4CF !important;\n  }\n  \n  /* k */\n  .toggleBtn_Kratos .toggle-button-cover {\n    position: relative;\n    top: 8px;\n  }\n  .dropdownSelectBtnCharging_Kratos{\n      width: fit-content;\n  }\n  .toggleBtn_Kratos .button-cover {\n    background-color: #fff;\n    box-shadow: 0 10px 20px -8px #c5d6d6;\n    border-radius: 4px;\n  }\n  \n  .toggleBtn_Kratos .button-cover:before {\n    color: #d7e3e3;\n    font-size: 12px;\n    line-height: 1;\n    padding: 5px;\n  }\n  \n  .toggleBtn_Kratos .button-cover,\n  .knobs,\n  .layer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n  \n  .toggleBtn_Kratos .buttonbtn {\n    position: relative;\n    top: 50%;\n    width: 50px;\n  }\n  \n  .toggleBtn_Kratos .buttonbtn.r,\n  .buttonbtn.r .layer {\n    border-radius: 100px;\n  }\n  \n  .toggleBtn_Kratos .button.b2 {\n    border-radius: 2px;\n  }\n  \n  .toggleBtn_Kratos .checkbox {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    opacity: 0;\n    cursor: pointer;\n    z-index: 3;\n  }\n  \n  .toggleBtn_Kratos .knobs {\n    z-index: 2;\n  }\n  \n  .toggleBtn_Kratos .layer {\n    width: 100%;\n    background-color: #ebf7fc;\n    transition: 0.3s ease all;\n    z-index: 1;\n  }\n  /* Button 1 */\n  #button-1_Kratos .knobs:before {\n    content: \"V\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 20px;\n    height: 20px;\n    color: #fff;\n    font-size: 10px;\n    font-weight: bold;\n    text-align: center;\n    line-height: 1;\n    padding: 6px 4px;\n    background-color: #83A4CF;\n    border-radius: 50%;\n    transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n  }\n  \n  #button-1_Kratos .checkbox:checked + .knobs:before {\n    content: \"C\";\n    left: 30px;\n    background-color: #3578b0;\n  }\n  \n  #button-1_Kratos .checkbox:checked ~ .layer {\n    /* fent orange change */\n    /* background-color: #fcebeb; */\n    background-color: #94c1e6;\n  }\n  \n  #button-1_Kratos .knobs,\n  #button-1_Kratos .knobs:before,\n  #button-1_Kratos .layer {\n    transition: 0.3s ease all;\n  }\n  \n  /***************************** PageTwo *******************************/\n  \n  /*************************  *****************************/\n  .kpiNotificationSlow_Kratos{\n      color: #83A4CF;\n      font-size: 0.7em;\n      font-weight: 500;\n  }\n  .kpiNotificationFast_Kratos{\n      color:#3578b0;\n      font-size:0.7em;\n      font-weight:500;\n  }\n  \n  .kpiNotificationBoth_Kratos{\n      color:#72D817;\n      font-size:0.7em;\n      font-weight:500;\n  }\n  /* media queries start here */\n  \n  @media (min-width: 1440px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  @media (max-width: 1440px) {\n  .highlightTableSec_Kratos{\n      min-height: 310px !important;\n  }\n  }\n  \n  @media (min-width: 1336px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  \n  @media (max-width: 1024px) {\n  .highlightTableSec_Kratos{\n      min-height: 330px !important;\n  }\n  }\n  \n  \n  @media (min-width: 992px) {\n  .col205{\n      flex: 0 0 auto;\n      width: 20% !important;\n  }\n  }\n  \n  \n  @media (min-width: 836px) {\n  /* .navbar-expand-sm { */\n      /* flex-wrap: nowrap !important; */\n      /* justify-content: flex-start !important; */\n  /* } */\n  }\n  \n  @media screen and (max-width: 740px) {\n  .chargingTitleBg_Kratos {\n      font-size: 0.9em;\n  }\n  }\n  \n  \n  @media screen and (max-width: 720px) {\n  /* .chargingMainDiv_Bus{ */\n      /* margin-top:124px; */\n  /* } */\n  }\n  \n  @media screen and (max-width: 480px) {\n  /* .chargingMainDiv_Bus{ */\n      /* margin-top:155px; */\n  /* } */\n  }\n      \n  @media screen and (max-width: 480px) {\n  \n  .chargingHeadfont_Kratos {\n      font-size: 1rem;\n  }\n  .chargingTitleBg_Kratos {\n      font-size: 0.9em;\n  }\n  }\n  \n  @media screen and (max-width: 320px) {\n  \n  }\n  \n  .highlight_five_Kratos{\n    margin: auto;\n  }\n  \n  .text_bottom_Kratos{\n    margin-bottom: '-16px !important';\n    display: none;\n    z-index: 1;\n  }\n  .btn-infotable_Kratos:active {\n    color: black;\n    background-color: #fff;\n    border-color: #32879c; \n  }\n  \n  /* .col-19 {\n    flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n  } */\n  \n  @media (min-width: 1440px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  @media (min-width: 1336px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  @media (min-width: 992px) {\n    .col-19 {\n      flex: 0 0 calc(100% / 19);\n    max-width: calc(100% / 19);\n    }\n  }\n  \n  \n  /* @media (max-width: 576px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 576px) and (max-width: 768px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 768px) and (max-width: 992px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  }\n  \n  @media (min-width: 992px) {\n    .col-19 {\n        flex: 0 0 calc(100% / 19);\n        max-width: calc(100% / 19);\n      }\n  } */\n  \n  .chargingChartboxNew_Kratos {\n    background: #FFFFFF;\n    padding: 0px;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    height: 293px;\n  }\n  \n  .highBold {\n    font-weight: bold;\n    color: black;\n    font-size:16px !important\n  }\n  \n  .filter_kratos_icon_f .rca_btn .rca_btn_kratos  {\n    background-color: #ffa650;\n  }\n  .filter_kratos_icon_f .rca_btn .rca_btn_kratos:hover{\n    background-color: #fcb877 !important; \n    border-color: #fcb877 !important;\n  }\n  \n  .popUpTable{\n    background-color: rgb(131, 164, 207);\n    color: rgb(255, 255, 255);\n    position: sticky;\n    top: 0;\n    z-index: 0;\n  }\n  \n  .custom-table .p-datatable-thead th {\n    background-color: #83A4CF;\n    /* Set your desired background color */\n    color: white;\n    /* Set your desired text color */\n  }\n  \n  /* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */\n  .custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {\n    color: white;\n    height: 20px!important;\n    width: 12px!important;\n    /* Set your desired arrow color */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chargingMainDiv_Kratos": `ChargingPageCustom_Kratos_chargingMainDiv_Kratos__Oy-sI`,
	"btn-primary": `ChargingPageCustom_Kratos_btn-primary__GQRHG`,
	"btn-outline-primary": `ChargingPageCustom_Kratos_btn-outline-primary__GlHzP`,
	"ev_filter_icon": `ChargingPageCustom_Kratos_ev_filter_icon__GD6TR`,
	"kpiSlowBTN_Kratos": `ChargingPageCustom_Kratos_kpiSlowBTN_Kratos__VVM-g`,
	"btn-check": `ChargingPageCustom_Kratos_btn-check__uKk+o`,
	"btn": `ChargingPageCustom_Kratos_btn__jlVTz`,
	"active": `ChargingPageCustom_Kratos_active__eQ8Ox`,
	"show": `ChargingPageCustom_Kratos_show__40hQW`,
	"disabled": `ChargingPageCustom_Kratos_disabled__q0hux`,
	"dropdown-toggle": `ChargingPageCustom_Kratos_dropdown-toggle__PAmzY`,
	"ev_SButton": `ChargingPageCustom_Kratos_ev_SButton__fMmwa`,
	"kpiFastBTN_Kratos": `ChargingPageCustom_Kratos_kpiFastBTN_Kratos__G-sw6`,
	"btn-outline-warning": `ChargingPageCustom_Kratos_btn-outline-warning__5fnp0`,
	"ev_FButton": `ChargingPageCustom_Kratos_ev_FButton__LeNUz`,
	"bg-white": `ChargingPageCustom_Kratos_bg-white__yJg2Y`,
	"chargingWidget_Kratos": `ChargingPageCustom_Kratos_chargingWidget_Kratos__Ns5aI`,
	"chargingWidgetIcon_Kratos": `ChargingPageCustom_Kratos_chargingWidgetIcon_Kratos__kNE7a`,
	"chargingWidgetIcon1_Kratos": `ChargingPageCustom_Kratos_chargingWidgetIcon1_Kratos__EFiH6`,
	"chargingWidgetIcon_Kratos-32_Kratos": `ChargingPageCustom_Kratos_chargingWidgetIcon_Kratos-32_Kratos__nsi6J`,
	"chargingTitleBg_Kratos": `ChargingPageCustom_Kratos_chargingTitleBg_Kratos__r8cqb`,
	"chargingTitleChart_Kratos": `ChargingPageCustom_Kratos_chargingTitleChart_Kratos__7pwL5`,
	"chargingChartbox_Kratos": `ChargingPageCustom_Kratos_chargingChartbox_Kratos__iWWsf`,
	"wd_Kratos": `ChargingPageCustom_Kratos_wd_Kratos__-v0cR`,
	"wd_4_charts_Kratos": `ChargingPageCustom_Kratos_wd_4_charts_Kratos__6FquW`,
	"highlightBoxKpi_Kratos": `ChargingPageCustom_Kratos_highlightBoxKpi_Kratos__0xe53`,
	"highlightTableSec_Kratos": `ChargingPageCustom_Kratos_highlightTableSec_Kratos__0DY8A`,
	"chargingChartHGT_Kratos": `ChargingPageCustom_Kratos_chargingChartHGT_Kratos__ujkIh`,
	"chargingH5_Kratos": `ChargingPageCustom_Kratos_chargingH5_Kratos__9bpAI`,
	"h5": `ChargingPageCustom_Kratos_h5__uVxsu`,
	"chargingKpiSmallTxt_Kratos": `ChargingPageCustom_Kratos_chargingKpiSmallTxt_Kratos__fdnqX`,
	"tableContent_Kratos": `ChargingPageCustom_Kratos_tableContent_Kratos__IIWV2`,
	"chargingFilterForm_Kratos": `ChargingPageCustom_Kratos_chargingFilterForm_Kratos__Y+-k5`,
	"form-label": `ChargingPageCustom_Kratos_form-label__Mk1TL`,
	"chargingHeadfont_Kratos": `ChargingPageCustom_Kratos_chargingHeadfont_Kratos__WYUd-`,
	"topRightDropMenu_Kratos": `ChargingPageCustom_Kratos_topRightDropMenu_Kratos__jdXt-`,
	"dropdown-menu": `ChargingPageCustom_Kratos_dropdown-menu__cnEb6`,
	"contentScroll_Kratos": `ChargingPageCustom_Kratos_contentScroll_Kratos__vCcDo`,
	"toggleBtn_Kratos": `ChargingPageCustom_Kratos_toggleBtn_Kratos__CezRZ`,
	"form-switch": `ChargingPageCustom_Kratos_form-switch__us3Zg`,
	"form-check-input": `ChargingPageCustom_Kratos_form-check-input__cZm8T`,
	"toggle-button-cover": `ChargingPageCustom_Kratos_toggle-button-cover__lpbDg`,
	"dropdownSelectBtnCharging_Kratos": `ChargingPageCustom_Kratos_dropdownSelectBtnCharging_Kratos__CgChf`,
	"button-cover": `ChargingPageCustom_Kratos_button-cover__pSwkC`,
	"knobs": `ChargingPageCustom_Kratos_knobs__W3lBd`,
	"layer": `ChargingPageCustom_Kratos_layer__HpCO0`,
	"buttonbtn": `ChargingPageCustom_Kratos_buttonbtn__4Ibpi`,
	"r": `ChargingPageCustom_Kratos_r__5u9x1`,
	"button": `ChargingPageCustom_Kratos_button__+W+io`,
	"b2": `ChargingPageCustom_Kratos_b2__eUTEH`,
	"checkbox": `ChargingPageCustom_Kratos_checkbox__h0pn5`,
	"button-1_Kratos": `ChargingPageCustom_Kratos_button-1_Kratos__cnPdg`,
	"kpiNotificationSlow_Kratos": `ChargingPageCustom_Kratos_kpiNotificationSlow_Kratos__7ER7N`,
	"kpiNotificationFast_Kratos": `ChargingPageCustom_Kratos_kpiNotificationFast_Kratos__I0Jk+`,
	"kpiNotificationBoth_Kratos": `ChargingPageCustom_Kratos_kpiNotificationBoth_Kratos__rAXDT`,
	"col205": `ChargingPageCustom_Kratos_col205__TISR7`,
	"highlight_five_Kratos": `ChargingPageCustom_Kratos_highlight_five_Kratos__qB2BU`,
	"text_bottom_Kratos": `ChargingPageCustom_Kratos_text_bottom_Kratos__kfXrW`,
	"btn-infotable_Kratos": `ChargingPageCustom_Kratos_btn-infotable_Kratos__nMhWs`,
	"col-19": `ChargingPageCustom_Kratos_col-19__KVKTO`,
	"chargingChartboxNew_Kratos": `ChargingPageCustom_Kratos_chargingChartboxNew_Kratos__5ORso`,
	"highBold": `ChargingPageCustom_Kratos_highBold__X-crn`,
	"filter_kratos_icon_f": `ChargingPageCustom_Kratos_filter_kratos_icon_f__cAFSw`,
	"rca_btn": `ChargingPageCustom_Kratos_rca_btn__lGWjQ`,
	"rca_btn_kratos": `ChargingPageCustom_Kratos_rca_btn_kratos__oKFaY`,
	"popUpTable": `ChargingPageCustom_Kratos_popUpTable__ApGz8`,
	"custom-table": `ChargingPageCustom_Kratos_custom-table__75i+K`,
	"p-datatable-thead": `ChargingPageCustom_Kratos_p-datatable-thead__jAi5u`,
	"p-sortable-column": `ChargingPageCustom_Kratos_p-sortable-column__6pzrP`,
	"p-column-header-content": `ChargingPageCustom_Kratos_p-column-header-content__6K7aF`,
	"p-sortable-column-icon": `ChargingPageCustom_Kratos_p-sortable-column-icon__w-Xkj`
};
export default ___CSS_LOADER_EXPORT___;
